exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".promos .header {\n  font-size: 24px; }\n\n.promos .card-content {\n  font-size: 17x; }\n\n.back {\n  background-color: #b4181d;\n  color: #fff;\n  border: 0px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/mall-shop-detail/mall-shop-detail.component.scss
// module id = ../../../../../src/app/mall-shop-detail/mall-shop-detail.component.scss
// module chunks = main